import * as Html from "../util/Html.ts";
import * as FwDatas from "../FwDatas.ts";
import ApiServer from "../ApiServer.ts";
import * as modal from "../util/modal.ts";
import * as i18n from "../i18n.ts";
import TPL from "../modal/reminder-custom.mustache";

Html.registerWidget('widget/reminder-select',{initDom})

const
  defaultOptionsAllDay = ["MINUTE-0","","HOUR-15","DAY-1","DAY-2"],
  defaultOptions = ["MINUTE-0","","MINUTE-5","MINUTE-15","MINUTE-30","HOUR-1","HOUR-2","DAY-1"],
  display = ApiServer.types.IReminder.html;

function initDom(element : HTMLElement){
  const
    el       = element as HTMLSelectElement,
    form     = el.form as HTMLFormElement,
    allDayInput = form.allDay;

  let
    value = el.getAttribute('data-value'),
    type  = el.getAttribute('data-type');


  function isAllday(){
    if(!allDayInput) return false;
    if(allDayInput.type==="checkbox") return allDayInput.checked
    return allDayInput.value === "true"
  }

  function backDataToForm(newValue ?:string){
    value = newValue;
    if(type==='task'){
      if(value){
        form['reminder.reminderType'].value = 'SNOOZE';
        form['reminder.reminderUnit'].value = value.split('-')[0];
        form['reminder.reminderValue'].value = value.split('-')[1];
      }else{
        form['reminder.reminderType'].value = 'NONE';
        form['reminder.reminderUnit'].value = 'HOUR';
        form['reminder.reminderValue'].value = 0;
      }
    }else if(type==='settings'){
      //settings case handle elsewhere
    }else if(type==='event'){
      const
        widgets = Array.from(
          document.querySelectorAll<HTMLSelectElement>('select[data-widget="widget/reminder-select"]')
        ).filter(item => item.value !== null && item.value !== ''),
        reminders = widgets.map(item => {
          const splitted = item.value.split('-');
          return {reminderType:"SNOOZE",reminderUnit:splitted[0],reminderValue:splitted[1]}
        });

      form.reminderList.value = JSON.stringify(reminders);
    }
  }

  function showNext(){
    const next = el.nextElementSibling as HTMLElement | null;
    if(next) next.style.display = '';
  }

  function initOptions(forceValue ?:string){
    const allDay = isAllday();
    let options: string[];
    if(forceValue!==undefined){
      value = forceValue
    }

    if(allDay){
      options = [].concat(defaultOptionsAllDay)
    }else{
      options = [].concat(defaultOptions)
    }

    if(value && options.indexOf(value)===-1){
      options.push(value)
    }

    el.innerHTML = options.map(str=>{
      const
        splitted = str.split('-'),
        unit     = str.length>1 ? splitted[0] : null,
        intValue = str.length>1 ? parseInt(splitted[1]) : undefined;
      return `<option value="${str}" ${str==value?"selected":""}>${display(unit,intValue,type,allDay)}</option>`;
    }).concat([`<option value="CUSTOM">${i18n.get('recurrency.custom')}</option>`]).join('');

  }

  function update(){
    initOptions();
    backDataToForm(el.value);
    if(type==='event' && value!==''){
      showNext();
    }
  }

  update();
  allDayInput?.addEventListener("change",function update(){
    const isFirstReminder = el.getAttribute("data-first")==='true';
    let forceValue = undefined;

    if(isFirstReminder){
      const
        allDay   = isAllday(),
        settings = FwDatas.getSettingsPerFamily();
      forceValue = (settings.defaultReminderType==='NONE'?"":(allDay?"MINUTE-0":settings.defaultReminderUnit+"-"+settings.defaultReminderValue)) ;
    }

    initOptions(forceValue);
    backDataToForm(el.value);
    if(type==='event' && value!==''){
      showNext();
    }
  });

  el.addEventListener('change', function(){
    if(el.value==='CUSTOM'){
      const theModal = modal.openDomModal(TPL,{});
      theModal.querySelector('[data-button="ok"]').addEventListener('click',function(evt){
        evt.preventDefault();
        value = theModal.querySelector('[name="unit"]').value+'-'+theModal.querySelector('[name="value"]').value;
        initOptions();
        backDataToForm(value);
        modal.closeDomModal(theModal);
      });

    }else{
      backDataToForm(el.value);
      if(type==='event' && value!==''){
        showNext();
      }
    }
  });

}
